<template>
  <div v-if="firmante">
    <h2 class="my-4">Edición de atributos del firmante: {{ firmante.nombre }} &lt;{{ firmante.email }}&gt;</h2>

    <!-- <b-row class="mb-2">
      <b-col cols="3"></b-col>
      <b-col cols="5" class="p-0">
        <div class="d-flex justify-content-between" style="width: 400px">
          <b-button :disabled="pagina == 1" @click="pagina--"><b-icon-arrow-left-circle></b-icon-arrow-left-circle></b-button>
          <div>{{ pagina }} / {{ pageCount }}</div>
          <b-button :disabled="pagina == pageCount" @click="pagina++"><b-icon-arrow-right-circle></b-icon-arrow-right-circle></b-button>
        </div>
      </b-col>
      <b-col cols="4"></b-col>
    </b-row> -->
    <b-row>
      <b-col cols="3" class="">
        <div class="mb-4">
          <strong>Instrucciones</strong>
          <ol class="pl-3">
            <li>Edita las características de la firma (modalidad, ...)</li>
            <li>Acepta para continuar con el siguiente o finalizar</li>
          </ol>
        </div>

        <div class="my-2 border alert alert-info" style="font-size: 0.8em">
          <h3>Recuerda</h3>
          <p>
            Un documento electrónico que ya haya sido firmado, pierde las evidencias anteriores si se vuelve a enviar para su firma electrónica por segunda vez.<br />
            Todos los firmantes de un documento deben llevar a cabo la firma electrónica en el mismo envío.
          </p>
          <p>Una firma electrónica abarca a todo el documento; con la firma electrónica ya no es necesario firmar en todas y cada una de las páginas.</p>
        </div>
      </b-col>
      <b-col cols="9">
        <b-row>
          <b-col cols="6">
            <div>
              <b-form-group label-class="font-weight-bold pt-0" label="Datos del firmante">
                <b-input-group prepend="Nombre" class="mb-2">
                  <b-form-input type="text" required placeholder="Nombre y apellidos del firmante" aria-label="nombre" :readonly="datosdelfirmantenoeditable" v-model="nombre"></b-form-input>
                </b-input-group>
                <b-input-group prepend="Email" class="mb-2" description="">
                  <b-form-input type="text" placeholder="Correo electrónico del firmante" aria-label="email" :readonly="datosdelfirmantenoeditable" v-model="email"></b-form-input>
                </b-input-group>
              </b-form-group>
            </div>
            <div>
              <b-form-group label-class="font-weight-bold pt-0" label="Pie de firma">
                <b-form-checkbox v-model="incluirpie" @input="fijarfirma" switch> Incluir información a pie de firma </b-form-checkbox>
                <div v-show="incluirpie" class="my-2">
                  <b-input-group prepend="Línea #1" class="mb-2">
                    <b-form-input type="text" required placeholder="(opc.) p.e. Fdo. D. ..." aria-label="pie_linea1" v-model="pie_linea1"></b-form-input>
                  </b-input-group>
                  <b-input-group prepend="Línea #2" class="mb-2" description="">
                    <b-form-input type="text" placeholder="(opc.) p.e. Director de ..." aria-label="pie_linea2" v-model="pie_linea2"></b-form-input>
                  </b-input-group>
                  <b-input-group prepend="Línea #3" class="mb-2" description="">
                    <b-form-input type="text" placeholder="(opc.) p.e. en representación de ..." aria-label="pie_linea3" v-model="pie_linea3"></b-form-input>
                  </b-input-group>
                  <b-form-checkbox v-model="pie_linea3segunsello" class="text-right">Autotexto (en línea #3), según sello empleado<br />(sin marcar, texto libre)</b-form-checkbox>
                </div>
              </b-form-group>
            </div>
          </b-col>
          <b-col cols="6">
            <div>
              <b-form-group label-class="font-weight-bold pt-0" label="Sello de empresa">
                <b-form-radio-group id="radio-selloempresa" v-model="selloempresa" :options="optionsselloempresa" @input="fijarfirma" stacked></b-form-radio-group>
              </b-form-group>
            </div>
            <div>
              <b-form-group label-class="font-weight-bold pt-0" label="Modalidad de firma">
                <b-form-radio-group id="radio-modofirma" v-model="modofirma" :options="optionsmodofirma" @input="fijarfirma" stacked></b-form-radio-group>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="w-100 d-flex justify-content-between mt-5">
              <b-button @click="cancelar" variant="danger">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                Cancelar
              </b-button>
              <b-button @click="guardar" class="bgcolor-manusa">
                Guardar cambios y continuar
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    pdfdoc: String,
    firmante: Object
  },
  data() {
    return {
      src: '',
      pagina: 1,
      pageCount: 0,
      nombre: '',
      email: '',
      incluirpie: false,
      pie_linea1: '',
      pie_linea2: '',
      pie_linea3: '',
      pie_linea3segunsello: true,
      // posicionX: 0,
      // posicionY: 0,
      selloempresa: '',
      optionsselloempresa: [{ text: 'Sin sello', value: 'sinsello', disabled: false, solomanusa: false }],
      modofirma: '',
      optionsmodofirma: [
        { text: 'Firma electrónica manuscrita', value: 'manuscrita', disabled: false, solomanusa: false },
        { text: 'Certificado digital de empresa (según sello)', value: 'cdsegunsello', disabled: true, solomanusa: true },
        { text: 'Certificado digital personal', value: 'cdpersonal', disabled: false, solomanusa: false }
        //{ text: 'This one is Disabled', value: 'third', disabled: true },
        //{ text: 'This is the 4th radio', value: { fourth: 4 } }
      ],
      sellos: []
    };
  },
  mounted() {
    this.$store.getters.misCertificadosDeEmpresa.forEach((c) => {
      this.optionsselloempresa.push({
        text: 'Sello de ' + c.nombre,
        value: 'sello' + c.codigo,
        disabled: true,
        solomanusa: true
      });
    });
    this.src = 'data:application/pdf;base64,' + this.pdfdoc;
    this.nombre = this.firmante.nombre;
    this.email = this.firmante.email;
    this.incluirpie = this.firmante.piefirma.activado;
    this.pie_linea1 = this.firmante.piefirma.linea1;
    this.pie_linea2 = this.firmante.piefirma.linea2;
    this.pie_linea3 = this.firmante.piefirma.linea3;
    this.pie_linea3segunsello = this.firmante.piefirma.linea3segunsello;
    // this.posicionX = this.firmante.posicionfirma.definida?this.firmante.posicionfirma.top:0
    // this.posicionY = this.firmante.posicionfirma.definida?this.firmante.posicionfirma.left:0
    this.modofirma = this.firmante.modofirma;
    this.selloempresa = this.firmante.selloempresa;
    if (this.firmante.esexterno) this.selloempresa = 'sinsello';
    if (this.firmante.esexterno) this.modofirma = 'manuscrita';

    for (let i = 0; i < this.optionsselloempresa.length; i++) {
      this.optionsselloempresa[i].disabled = this.firmante.esexterno && this.optionsselloempresa[i].solomanusa;
    }
    for (let i = 0; i < this.optionsmodofirma.length; i++) {
      this.optionsmodofirma[i].disabled = !this.firmante.permitefirmadeempresa && this.firmante.esexterno && this.optionsmodofirma[i].solomanusa;
    }
  },
  methods: {
    fijarfirma() {
      if (this.pie_linea3segunsello) this.pie_linea3 = this.textorepresentacionsegunsello;

      // si se ha escogido sello de empresa, se activa la opción de firma con cd-empresa
      if (this.selloempresa === 'sinsello') {
        this.optionsmodofirma[1].disabled = true;
        // si estuviese escogida la opción desactivada, se fuerza al modo manuscrita
        if (this.modofirma === 'cdsegunsello') this.modofirma = 'manuscrita';
      } else {
        this.optionsmodofirma[1].disabled = false; //si es con sello, se reactiva el modo firma certificado de empresa
      }
    },
    cancelar() {
      this.$emit('cancelar-edicion');
    },
    guardar() {
      const atributos = {
        id: this.firmante.id,
        empresa: this.firmante.empresa,
        cargo: this.firmante.cargo,
        efirmadefinida: false,
        esexterno: this.esexterno,
        nombre: this.nombre,
        email: this.email,
        piefirma: {
          activado: this.incluirpie,
          linea1: this.pie_linea1,
          linea2: this.pie_linea2,
          linea3: this.pie_linea3,
          linea3segunsello: this.pie_linea3segunsello
        },
        posicionfirma: {
          definida: true,
          pagina: 0,
          top: 0,
          left: 0,
          height: 0,
          width: 0
        },
        modofirma: this.modofirma,
        selloempresa: this.selloempresa
      };
      console.log(atributos);
      this.$emit('guardar-cambios-edicion', atributos);
    }
  },
  computed: {
    srcselloseleccionado() {
      return this.sellos[this.selloempresa];
    },
    datosdelfirmantenoeditable() {
      return this.email.split('@')[1] === 'manusa.com';
    },
    textorepresentacionsegunsello() {
      if (this.selloempresa === 'sinsello') return '';
      const mcde = this.$store.getters.misCertificadosDeEmpresa.filter((c) => c.sello === this.selloempresa)[0];
      return 'En representación de ' + mcde.nombre;
    }
  }
};
</script>
<style scoped></style>
